module.exports = __webpack_public_path__ + "static/media/community-game.e382e4e7.png";